import { useEffect, useRef } from 'react';

//the effect will only run after the component has mounted (i.e., not during the first render).
const useEffectAfterMount = (callback, dependencies) => {
    const isFirstRender = useRef(true);

    useEffect(() => {
        if (isFirstRender.current) {
            isFirstRender.current = false;

            return;
        }

        return callback();
    }, dependencies);
};

export default useEffectAfterMount;
